import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@ontruck/orc';
import { sendEventToSegment } from 'utils/functions/Tracking';
import TRACKING_EVENTS from 'utils/constants/trackingEvents';
import { useAuth } from 'hooks/useAuth/useAuth';
import ButtonLoading from 'components/ButtonLoading';

const BannerAcceptComCom = ({ className }) => {
  const { answerCommercialCommunications, loading } = useAuth();
  const { t } = useTranslation('Banner');
  const [accepted, setAccepted] = useState(false);
  const onAcceptChange = checked => {
    setAccepted(checked);
  };
  const onAcceptClick = async () => {
    await answerCommercialCommunications(accepted);
    sendEventToSegment(TRACKING_EVENTS.BANNER_ACCEPT_COM_COM, { accepted });
  };

  return (
    <div className={className} data-testid="banner-accept-com-com">
      <div className="banner-accept-com-com">
        <div className="banner-accept-com-com__title">
          {t('BannerAcceptComComTitle')}
        </div>
        <div className="banner-accept-com-com__body">
          <Checkbox
            name="accept-com-com"
            onChange={(_, { value }) => onAcceptChange(value)}
            label={t('BannerAcceptComComBody')}
            disabled={loading}
          />
        </div>
        <ButtonLoading
          fullWidth
          testId="com-com-btn"
          loading={loading}
          handleClick={onAcceptClick}
          text={t('BannerAcceptComComAction')}
        />
      </div>
    </div>
  );
};
BannerAcceptComCom.propTypes = {
  className: PropTypes.string
};
export default BannerAcceptComCom;
